import React from 'react';
import Card from '../../../../core/layout/Card';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import LearningCorrectAnswersRateGaugeContainer from './LearningCorrectAnswersRateGaugeContainer';
import LearningReachedLevelRateGaugeContainer from './LearningReachedLevelRateGaugeContainer';

const LearningGlobalTab = () => (
  <div>
    <Card>
      <Row>
        <Column size={6}>
          <LearningCorrectAnswersRateGaugeContainer />
        </Column>
        <Column size={6}>
          <LearningReachedLevelRateGaugeContainer />
        </Column>
      </Row>
    </Card>
  </div>
);

export default LearningGlobalTab;
